import {createSlice} from '@reduxjs/toolkit';
import {TreatmentColorsDto} from 'src/shared/services/treatment-colors/dto/treatment-color-dto';

interface treatmentColorsInitialState {
  treatmentColorsDetails: TreatmentColorsDto | undefined;
}

const initialState: treatmentColorsInitialState = {
  treatmentColorsDetails: undefined,
};

const treatmentColorsSlice = createSlice({
  name: 'treatmentColors',
  initialState: initialState,
  reducers: {
    setTreatmentColorsDetails: (state, action) => {
      state.treatmentColorsDetails = action.payload;
    },
  },
});

export const {setTreatmentColorsDetails} = treatmentColorsSlice.actions;

export default treatmentColorsSlice.reducer;
